// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CXlesqgIQUSV4u {
  width: 1px;
  height: 1px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  border: 0;
  pointer-events: none;
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
}
.I1mTB4BD1hFm9_ {
  position: relative;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  border-radius: var(--ds-border-radius-050, 2px);
  white-space: nowrap;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
._YkpCYXvyvhfi9 {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac ._YkpCYXvyvhfi9 {
  outline-color: -webkit-focus-ring-color;
}
._YkpCYXvyvhfi9 .mac.firefox {
  outline-color: AccentColor;
}
.IuheDHJK8HXNdR {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.ZAcH7Pr9TT7uUR {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  height: 16px;
  opacity: 0;
}
.ZAcH7Pr9TT7uUR svg {
  fill: transparent;
}
.llQZ8KQKbYje7j {
  display: inline-flex;
  position: relative;
  align-items: center;
  padding-top: 6px;
  padding-right: 8px;
  padding-bottom: 6px;
  font-weight: var(--ds-font-weight-bold, 700);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
}
.brswMGcsPngDot {
  margin-left: var(--ds-space-100, 8px);
}
.QAbIzaY_2ICVlA:hover .I1mTB4BD1hFm9_ {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.QAbIzaY_2ICVlA:hover .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  background-color: var(--ds-background-selected-bold-hovered, #0055cc);
  box-shadow: inset 0 0 0 1px var(--ds-border-selected, #0c66e4);
}
.QAbIzaY_2ICVlA:active .I1mTB4BD1hFm9_,
.QAbIzaY_2ICVlA:active .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ {
  background-color: var(--ds-background-input-pressed, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-focused, #388bff);
}
.QAbIzaY_2ICVlA:active .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR {
  width: 16px;
  height: 16px;
  opacity: 1;
}
.QAbIzaY_2ICVlA:active .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR svg {
  fill: var(--ds-icon-selected, #0c66e4);
}
.CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_,
.PD66ZAx9ZX1oTJ {
  background-color: var(--ds-background-selected-bold, #0c66e4);
  box-shadow: inset 0 0 0 1px var(--ds-border-selected, #0c66e4);
}
.CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR,
.PD66ZAx9ZX1oTJ .ZAcH7Pr9TT7uUR {
  width: 16px;
  height: 16px;
  opacity: 1;
}
.CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR svg,
.PD66ZAx9ZX1oTJ .ZAcH7Pr9TT7uUR svg {
  fill: var(--ds-icon-inverse, #ffffff);
}
.d010nUn_qIUM4C,
.d010nUn_qIUM4C:hover,
.d010nUn_qIUM4C:active {
  cursor: not-allowed;
}
.d010nUn_qIUM4C .I1mTB4BD1hFm9_,
.d010nUn_qIUM4C:hover .I1mTB4BD1hFm9_,
.d010nUn_qIUM4C:active .I1mTB4BD1hFm9_ {
  pointer-events: none;
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 1px var(--ds-border-disabled, #091e420f);
}
.d010nUn_qIUM4C .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_,
.d010nUn_qIUM4C:hover .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_,
.d010nUn_qIUM4C:active .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ {
  pointer-events: none;
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 1px var(--ds-border-disabled, #091e420f);
}
.d010nUn_qIUM4C .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR,
.d010nUn_qIUM4C:hover .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR,
.d010nUn_qIUM4C:active .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR {
  width: 16px;
  height: 16px;
  opacity: 1;
}
.d010nUn_qIUM4C .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR svg,
.d010nUn_qIUM4C:hover .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR svg,
.d010nUn_qIUM4C:active .CXlesqgIQUSV4u:checked + .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR svg {
  fill: var(--ds-icon-disabled, #091e424f);
}
.QAbIzaY_2ICVlA.xhfxPD5ZpmwGv6 .I1mTB4BD1hFm9_ {
  background-color: var(--ds-background-selected-bold, #0c66e4);
  box-shadow: inset 0 0 0 1px var(--ds-border-selected, #0c66e4);
}
.QAbIzaY_2ICVlA.xhfxPD5ZpmwGv6 .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR {
  width: 16px;
  height: 16px;
  opacity: 1;
}
.QAbIzaY_2ICVlA.xhfxPD5ZpmwGv6 .I1mTB4BD1hFm9_ .ZAcH7Pr9TT7uUR svg {
  fill: var(--ds-icon-inverse, #ffffff);
}
`, ""]);
// Exports
var _1 = `CXlesqgIQUSV4u`;
export { _1 as "nch-checkbox__input" };
var _2 = `I1mTB4BD1hFm9_`;
export { _2 as "nch-checkbox__box" };
var _3 = `_YkpCYXvyvhfi9`;
export { _3 as "nch-checkbox__box--focusVisible" };
var _4 = `IuheDHJK8HXNdR`;
export { _4 as "nch-checkbox__box--invalid" };
var _5 = `ZAcH7Pr9TT7uUR`;
export { _5 as "nch-checkbox__checkIcon" };
var _6 = `llQZ8KQKbYje7j`;
export { _6 as "nch-checkbox__label" };
var _7 = `brswMGcsPngDot`;
export { _7 as "nch-checkbox__labelContent" };
var _8 = `QAbIzaY_2ICVlA`;
export { _8 as "nch-checkbox" };
var _9 = `PD66ZAx9ZX1oTJ`;
export { _9 as "nch-checkbox__checkedBox" };
var _a = `d010nUn_qIUM4C`;
export { _a as "nch-checkbox--disabled" };
var _b = `xhfxPD5ZpmwGv6`;
export { _b as "nch-checkbox--indeterminate" };
export default ___CSS_LOADER_EXPORT___;
